import { ReactNode } from "react";
import { Input, Textarea } from "@mui/joy";

export type CustomTextFieldProps = {
  error?: boolean;
  multiline?: boolean;
  rows?: number;
  fullWidth?: boolean;
  placeholder?: string;
  value?: string;
  name?: string;
  type?: string;
  autoComplete?: string;
  disabled?: boolean;
  startDecorator?: ReactNode;
  endDecorator?: ReactNode;
  onChange?: any;
  sx?: any;
};

export const CustomTextField = ({
  error,
  multiline,
  rows = 4,
  fullWidth,
  sx,
  ...props
}: CustomTextFieldProps) => {
  const sharedSx = {
    width: fullWidth ? "100%" : undefined,
    bgcolor: error ? "danger.softBg" : "background.level1",
    borderColor: error ? "danger.outlinedBorder" : "divider",
    boxShadow: "sm",
    "&:hover": {
      borderColor: error ? "danger.outlinedBorder" : "primary.300",
    },
    "&:focus-within": {
      borderColor: error ? "danger.outlinedBorder" : "primary.500",
      boxShadow: error ? "0 0 0 3px rgba(248,50,50,0.16)" : "0 0 0 3px rgba(24,93,231,0.16)",
    },
    ...sx,
  };

  if (multiline) {
    return (
      <Textarea
        {...props}
        minRows={rows}
        color={error ? "danger" : "neutral"}
        variant="outlined"
        sx={sharedSx}
      />
    );
  }

  return (
    <Input
      {...props}
      color={error ? "danger" : "neutral"}
      variant="outlined"
      sx={sharedSx}
    />
  );
};
